import styled from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import Config from '@config';

export const StyledAddressChanger = styled.div`
  margin-bottom: ${rem(16)};
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${rem(20)} 0 ${rem(20)};
`;

export const StyledAddressChangerLeft = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: ${rem(16)};

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    padding-right: ${rem(20)};
  }
`;

export const StyledAddressChangerButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${variables.colors.highlight};
  font-family: ${variables.fonts.fontGothamMedium};
  font-size: ${rem(13)};

  &:disabled {
    color: ${variables.colors.darkGray};
    cursor: default;
  }
`;

export const StyledInlineText = styled.span`
  font-family: ${variables.fonts.fontGothamBook};
`;
